<template>
  <div class="text-center">



   


<v-snackbar
      v-model="mensaje.snackbar"
      :timeout="mensaje.timeout"
      :color="mensaje.color"
      text
      top
      right
    >
      {{ mensaje.text }}

      <template v-slot:action="{ attrs }">
<v-btn
          :color="mensaje.colorBtn"
          text
          v-bind="attrs"
          @click="mensaje.snackbar = false"
        >
          Close
        </v-btn>
      </template>
    </v-snackbar>






    <v-dialog
      v-model="dialog"
      width="500"
    >


     <v-overlay :value="loading" opacity="0.8" absolute>
          <div class="d-flex flex-column align-center justify-center">
            <v-progress-circular
              indeterminate
              size="48"
              color="primary"
              class="mb-3"
            ></v-progress-circular>
            <span class="white--text font-weight-medium">Subiendo archivo...</span>
          </div>
        </v-overlay>




    
      <template v-slot:activator="{ on, attrs }">
       
       <v-btn 
       v-bind="attrs"
          v-on="on"
          icon
          data-cy="add-principal-input"
       @click="principalEditImg" 
       >
       
       <v-icon left>mdi-image-edit</v-icon></v-btn>
       
      </template>

      <v-card>

      <!--  <v-card-title class="text-h5" >
     Imagen no puede superar 5mb
    </v-card-title>-->








        
      

        <v-card-text>


<!-- INICIO DIALOG DATA

      <div class="my-2">
      <v-btn @click="dialogData = true">check data</v-btn>
    </div> -->

     <v-dialog
      v-model="dialogData"
    >
      <v-card>
    Principal Zoom
        {{this.principal.zoom}}

offsetX
          {{this.principal.fotox}}

offsetY
            {{this.principal.fotoy}}

        <v-card-title>USUARIO
          <v-spacer></v-spacer>
          <v-btn outlined color="info" text @click="dialogData = false">CLOSE</v-btn>
        </v-card-title>
          <v-card-text class="pprint">{{ usuario }}</v-card-text>

        <v-card-title>PRINCIPAL </v-card-title>


        
       <v-card-text class="pprint">{{ principal }}</v-card-text>

        
        
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn outlined color="info" text @click="dialogData = false">CLOSE</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
 


<!-- FIN DIALOG DATA -->






          
          <v-container>
    <v-row>

        <v-col cols="12">
          <v-form
      ref="form"
      v-model="valid"
      lazy-validation
    >
 <v-row no-gutters>
    </v-row>
    
  
      <v-col cols="12">

<v-avatar
size="20vh"
class="ma-0"
>
    
 <!-- <a data-fancybox data-caption="Single image" :href="server_url+'api/principal/get_image/'+principal.identificador+'/'+ principal.linkPhoto"> -->
       
  <div style="display: inline-block;" ref="container">
  <img 
        @mousedown="startDrag"
  @touchstart="startDrag"
        
        :src="server_url +'api/principal/get_image/'+principal.identificador+'/'+principal.linkPhoto"
        
        :style="{
    height: '20vh',
    transform: 'scale(' + zoom / 50 + ') translate(' + offsetX + 'px,' + offsetY + 'px)',
    transition: 'transform 0.2s'
  }"

        />

        </div>


       <!-- </a>  -->

    </v-avatar>

<v-card-text>
  <v-slider
    v-model="zoom"
    append-icon="mdi-magnify-plus-outline"
    prepend-icon="mdi-magnify-minus-outline"
    @click:append="zoomIn"
    @click:prepend="zoomOut"
    @input="onZoomChange"
  ></v-slider>
  <!-- <p>Zoom: {{ zoom }}</p>
  <p>Zoom p: {{ principal.zoom }}</p> -->

  <v-slider 
    prepend-icon="mdi-gesture-swipe-horizontal"
  @input="onXChange" v-model="offsetX" min="-100" max="100" label=""></v-slider>
    <!-- <p>offsetX: {{ offsetX }}</p>
     <p>fotoX: {{ this.principal.fotox }}</p> -->
  <v-slider
  prepend-icon="mdi-gesture-swipe-vertical"
  
  @input="onYChange" v-model="offsetY" min="-100" max="100" label=""></v-slider>
<!-- 
  <p>offsetY: {{ offsetY }}</p>
     <p>fotoY: {{ this.principal.fotoy }}</p> -->
</v-card-text>


          <v-file-input
            v-if="!fileData.url"
            v-model="archivo"
            show-size
            chips
            label="Adjuntar Imagen"
            prepend-icon="mdi-file"
            @change="uploadFile"
            ref="file_perfil"
            data-cy="file-input"
          ></v-file-input>
          <div v-if="fileData.url">
            <p>Archivo Agregado</p>
            <span>
              <a :href="server_url +'api/principal/get_image/'+principal.identificador+'/'+ fileData.url">
                {{ fileData.name }}
                <v-icon color="blue">mdi-download</v-icon>
              </a>
              <button @click="removeFile()">
                <v-icon color="red">mdi-delete</v-icon>
              </button>
            </span>
          </div>
   



<v-tooltip bottom>
  <template v-slot:activator="{ on, attrs }">
    <v-btn
      color="gray"
      class="mr-4 mt-4"
      v-bind="attrs"
      v-on="on"
      @click="recuperarFoto"
    >
      <v-icon left>mdi-image-area-close</v-icon>
      Recuperar Foto de Google
    </v-btn>
  </template>
  <span>Solo disponible para usuarios que ingresaron con Login With Google</span>
</v-tooltip>



      </v-col>
<v-divider class="mb-4"></v-divider>
    <v-col
        cols="12"
        md="12"
      >

      <v-text-field
           v-model="principal.nombre"
           label="Nombre"
           disabled
         ></v-text-field>

          

   
 <v-text-field
           v-model="principal.identificador"
           label="Identificador"
           disabled
         ></v-text-field>




       
      </v-col>

      <v-divider></v-divider>

        <v-card-actions>

            <v-btn
        :disabled="!valid"
        color="success"
        class="mr-4"
        @click="registrarPrincipal"
      >
        Registrar
      </v-btn>

     

          
           <v-btn
        color="error"
        class="mr-4"
        @click="dialog = false"
      >
        Cancelar
      </v-btn>

<v-spacer></v-spacer>


   
        </v-card-actions>

      
    </v-form> 

        </v-col>
    </v-row>
  </v-container>

        </v-card-text>

        
      </v-card>
    </v-dialog>
  </div>
</template>


<script>

import Compressor from 'compressorjs';

import principalService from "@/services/principalService.js";

import { Fancybox } from '@fancyapps/ui';
import '@fancyapps/ui/dist/fancybox/fancybox.css';


import { http } from "@/services/config";


  export default {
    name:"PrincipalImg",

     props: {
    principalData: {
      type: Object, // Tipo de dato correspondiente al objeto del autor
      default: () => ({}) // Valor por defecto, un objeto vacío si no se proporciona
    },

  },

    data: () => ({
      loading: false,
      mensaje:{
          snackbar: false,
          text: '',
          color:'',
          timeout: -1,
      },
      offsetX: 0,
  offsetY: 0,
      zoom:50,
      dragging: false,
  startX: 0,
  startY: 0,
      dialog:false,
      dialogData: false,
      archivo: null,
      fileData: {
        url: "",
        name:""
      },
       server_url: "",
       usuario:{
      id:'',
      name:'',
      identificador:'',
      email:'',
      password:''
              },
      principal:{

id:'',
nombre:'',
apellido:'',
identificador:'',
descripcion:'',
linkPhoto:'',
observacion:'',
linkVideo:'',
zoom:50,
fotox:0,
fotoy:0,
          
        }
    ,
       valid: false,
    rules: {
                  required: value => !!value || 'Campo Requerido',
                  min: v => v.length >= 5 || 'Minimo 5 caracteres',
                  emailMatch: () => (`The email and password you entered don't match`),
                },
        	messages:undefined,
        
        
        
         textRules: [
              (v) => !!v || "Campo es requerido",
              (v) => (v && v.length >= 1) || "Debe contener al menos 3 caracteres",
            ],
        
            emailRules:  [
              (v) => !!v || "Correo es requerido",
              (v) => /.+@.+\..+/.test(v) || "Correo debe ser valido",
            ],
             numberRules: [
              (v) => (v >= 0) || "Valor debe ser mayor o igual a 0",
            ],
     
    }),
  created(){
  
       }
  ,mounted(){

   
 

     this.server_url = http.defaults.baseURL;


     if(this.principal.zoom){
      this.zoom=this.principal.zoom;
      console.log("valor zoom");
     }else{

      console.log("null zoom");
     
     }


  //    if (this.principal.fotox != null) {
  //   this.offsetX = this.principal.fotox;
  // }
  // if (this.principal.fotoy != null) {
  //   this.offsetY = this.principal.fotoy;
  // }

     if(this.principal.fotox){
      this.offsetX=this.principal.fotox;
      console.log("valor offsetX");
     }else{

      console.log("null offsetX");
     
     }

     if(this.principal.fotoy){
      this.offsetY=this.principal.fotoy;
      console.log("valor offsetY");
     }else{

      console.log("null offsetY");
     
     }

       // Eventos globales para mouse y touch
  window.addEventListener('mousemove', this.onDrag);
  window.addEventListener('mouseup', this.endDrag);
  window.addEventListener('touchmove', this.onDrag);
  window.addEventListener('touchend', this.endDrag);
   
    
    },
    beforeDestroy() {
  window.removeEventListener('mousemove', this.onDrag);
  window.removeEventListener('mouseup', this.endDrag);
  window.removeEventListener('touchmove', this.onDrag);
  window.removeEventListener('touchend', this.endDrag);
},

    methods:{

      recuperarFoto(){

          principalService.recuperarFoto(this.principal).then(res =>{


        let mensajeText = 'Imgen recuperada exitosamente de redes sociales';


        this.mensaje.text=mensajeText;

        this.mensaje.color="primary";
        this.mensaje.colorBtn="blue";

        this.mensaje.snackbar="true";



            this.removeFile();



            

 this.principal.linkPhoto=res.data.principal.linkPhoto;
           // this.principal.nombre=res.data.principal.nombre;
           //  this.principal.identificador=res.data.principal.identificador;
         this.fileData.url=res.data.principal.linkPhoto;

         console.log(this.principal);



       
        }).catch((errors) =>{

           console.log('error');
            console.log(errors);

            let mensajeError = '';

          mensajeError += "\n"+"Error: "+errors.response.data.error;

            this.mensaje.text=mensajeError;

      this.mensaje.snackbar="true";

      this.mensaje.color="error";
      this.mensaje.colorBtn="error";



        })

      },

      async recaptcha() {
  try {
    
    await this.$recaptchaLoaded();

    const token = await this.$recaptcha('login');

    
    return token;
  } catch (error) {
    console.error('Error al ejecutar reCAPTCHA:', error);
    throw error; 
  }
}
,


buildUrl(identificador, url) {
      return `${this.server_url}api/principal/get_image/${identificador}/${encodeURIComponent(url)}`;
    },

     zoomOut () {
        this.zoom = (this.zoom - 20) || 0
      },
      zoomIn () {
        this.zoom = (this.zoom + 20) || 200
      },

      startDrag(event) {
    this.dragging = true;
    const e = event.type.includes('touch') ? event.touches[0] : event;
    this.startX = e.clientX - this.offsetX;
    this.startY = e.clientY - this.offsetY;
  },
  onDrag(event) {
  if (!this.dragging) return;
  const e = event.type.includes('touch') ? event.touches[0] : event;

  this.offsetX = e.clientX - this.startX;
  this.offsetY = e.clientY - this.startY;

  // Asigna las coordenadas al objeto principal
  this.principal.fotox = this.offsetX;
  this.principal.fotoy = this.offsetY;
},
  endDrag() {
    this.dragging = false;
  },





    /* uploadFile: function () {
      this.principal.linkPhoto=this.fileData.url;
      if (this.archivo) this.submitFile();
      else this.removeFile();
    }*/
  
uploadFile: function () {
  if (!this.archivo) {
    this.removeFile();
    return;
  }

  // Comprimir la imagen antes de continuar
  new Compressor(this.archivo, {
    quality: 0.7,
    maxWidth: 1280,
    convertSize: 500000, // si es mayor a 500kb, convertir a JPEG
     success: (compressedBlob) => {
    const originalName = this.archivo.name.replace(/\.(jpe?g|png|jfif|webp)$/i, '');
    const newFile = new File([compressedBlob], originalName + '.jpg', {
      type: 'image/jpeg',
      lastModified: Date.now(),
    });

    this.fileData.name = newFile.name;
    this.principal.linkPhoto = this.fileData.url;

    this.submitFile(newFile);
  },
    error: (err) => {
      console.error('Error al comprimir imagen:', err.message);
      // en caso de error, seguir con el archivo original
      this.submitFile(this.archivo);
    },
  });
},

    



   async submitFile(archivoAEnviar) {


     this.loading = true; // inicia loading

   // this.fileData.name=this.archivo.name;
  // this.fileData.name=this.archivoAEnviar.name;
      console.log(this.archivoAEnviar);
      const formData = new FormData();




      try {
        console.log("obteniendo el token de recaptcha 2502");
    const tokenr = await this.recaptcha(); // Espera hasta que recaptcha() termine
    //console.log('Token obtenido:', token);
    formData.append("recaptcha", tokenr);

        } catch (error) {
  
console.error('Error en reCAPTCHA:', error);
  //this.loading = false;
  return;

  }



      formData.append("principal", JSON.stringify(this.principal));
      formData.append("file_perfil", archivoAEnviar);
      formData.append("identificador", this.principal.identificador);
      formData.append("user_id", this.principal.user_id);
    
      const headers = { 
      "Content-Type": "multipart/form-data" ,
      'Authorization':'Bearer '+ localStorage.getItem("token")
    };

    /*  console.log(formData);
      http
        .post(this.server_url + "api/principal/save_img/", formData, { headers })
        .then((res) => {
        
           this.principal.linkPhoto=res.data.principal.linkPhoto;
             console.log("en respuesta"+this.principal.linkPhoto);
            this.principal.nombre=res.data.principal.nombre;
             this.principal.identificador=res.data.principal.identificador;
         this.fileData.url=res.data.principal.linkPhoto;

         console.log(this.principal);
        }).catch((errors) =>{

           console.log('error');
            console.log(errors);
        })*/


try {
    const res = await http.post(this.server_url + "api/principal/save_img/", formData, { headers });
    this.principal.linkPhoto = res.data.principal.linkPhoto;
    this.principal.nombre = res.data.principal.nombre;
    this.principal.identificador = res.data.principal.identificador;
    this.fileData.url = res.data.principal.linkPhoto;
    console.log(this.principal);
  } catch (errors) {
    console.log('error', errors);
  } finally {
    this.loading = false; // termina loading
  }









    },
    removeFile() {
        this.fileData = { url: "" };
      
        this.archivo=null;

        this.principal.linkPhoto='';
  
    },

     principalEditImg(){
      console.log(this.principalData);
      this.principal=this.principalData;
      this.principal.opciones=[];
    },
    
    colorEdit(){
      console.log(this.color);
    },
    registrarPrincipal(){

            if (this.$refs.form.validate()) {

              let res;
   // this.redirect='/principal';

  console.log('El ide esta vacio '+this.principal.id);

  
     //   this.principal.color='#1F7087';
    if(this.principal.id===""){

        console.log('El ide esta vacio modif 25-02'+this.principal.id);





            principalService.save(this.principal).then(
        response =>{
            res= response.data.status,
            console.log('success');

            console.log(response.data);
       
        }).catch((errors) =>{

           console.log('error');
            console.log(errors);
        })
        console.log(res);
            
            this.$emit('principalEditImg',this.principal);
            this.dialog=false;
            
    }else{

      console.log("Ingrese a actualizar");

      console.log(this.principal);
    principalService.update(this.principal).then(
        response =>{
            res= response.data.status,
            console.log('success');

            console.log(response.data);
       
        }).catch((errors) =>{

           console.log('error');
            console.log(errors);
        })
        console.log(res);
            }
            this.$emit('principalEditImg',this.principal);
            this.dialog=false;
        }
        
        }

        
        ,
    validate(){
      if (this.$refs.form.validate()) {
        this.snackbar = true;
      }
    },
    reset() {
    //  this.$refs.form.reset();
      this.limpiar();
    },
    resetValidation() {
      this.$refs.form.resetValidation();
    }
    ,
    limpiar(){

     
		this.principal={
				nombre:'',
        apellido:'',
				linkPhoto:'',
				descripcion:'',
				observacion:'',
				id:'',
	}
    },

    onZoomChange(value) {
     // console.log('Zoom cambiado a:', value);
      this.principal.zoom=value;
    },
     onXChange(value) {
     // console.log('Zoom cambiado a:', value);
      this.principal.fotox=value;
    },
     onYChange(value) {
     // console.log('Zoom cambiado a:', value);
      this.principal.fotoy=value;
    },
    


    },

   
  watch: {

     // Watcher para monitorear cambios en principal.zoom  
     'principal.zoom'(newZoom) {
      this.zoom = newZoom;
    },
     'principal.offsetX'(valuex) {
      this.offsetX = valuex;
    },
     'principal.offsetY'(valuey) {
      this.offsetY = valuey;
    }

    
  }
  }
</script>

<style scoped>

.pprint {
  white-space:pre-wrap;
  word-wrap:break-word;
}
</style>